(function () {
  'use strict';

  if (window.FlorameShopifyAccountUi && window.FlorameShopifyAccountUi.loaded) return;

  var ACCOUNT_SELECTOR = 'shopify-account[data-florame-shopify-account]';
  var observedRoots = typeof WeakSet === 'function' ? new WeakSet() : null;
  var emailRequestedAccounts = typeof WeakSet === 'function' ? new WeakSet() : null;
  var emailRequestedRoots = typeof WeakSet === 'function' ? new WeakSet() : null;
  var marketingConsentReviewedRoots = typeof WeakSet === 'function' ? new WeakSet() : null;
  var swipeBoundDialogs = typeof WeakSet === 'function' ? new WeakSet() : null;
  var shopAttemptBoundRoots = typeof WeakSet === 'function' ? new WeakSet() : null;
  var scheduled = false;
  var viewportScheduled = false;
  var SHOP_ATTEMPT_KEY = 'florame_shop_login_attempted_at';

  function isItalian() {
    var language = String(document.documentElement.lang || navigator.language || 'it').toLowerCase();
    return language.indexOf('it') === 0;
  }

  function isWebView() {
    if (window.FlorameNative && window.FlorameNative.isNative) return true;
    var ua = String(navigator.userAgent || '');
    var androidWebView = /;\s*wv\)/i.test(ua) || (/Android/i.test(ua) && /Version\/4\.0/i.test(ua));
    var iosWebView = /(iPhone|iPad|iPod).*AppleWebKit/i.test(ua) && !/Safari/i.test(ua);
    return androidWebView || iosWebView;
  }

  function isMobileViewport() {
    return window.matchMedia ? window.matchMedia('(max-width: 989px)').matches : window.innerWidth <= 989;
  }

  function appendStyle(root, id, css) {
    if (!root || root.querySelector('style[data-florame-style="' + id + '"]')) return;
    var style = document.createElement('style');
    style.setAttribute('data-florame-style', id);
    style.textContent = css;
    root.appendChild(style);
  }

  function normalizedText(element) {
    return String(element && element.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function isRendered(element) {
    if (!element || !element.getBoundingClientRect) return false;
    var rect = element.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0 && (!element.getClientRects || element.getClientRects().length > 0);
  }

  function isEmailSwitchText(text) {
    return text === 'use email instead'
      || text === 'usa email'
      || text === "usa l'email"
      || text === 'usa l\u2019email';
  }

  function isShopActionText(text) {
    return text === 'sign in with shop'
      || text === 'continue with shop'
      || text === 'log in with shop'
      || text === 'accedi con shop'
      || text === 'continua con shop';
  }

  function shouldAutoOpenEmail() {
    // Shopify swaps and remounts the login subtree asynchronously. Clicking its
    // "use email" control during that transition causes visible jumps, stale
    // recognition state and, on some devices, a stuck Shop spinner. Keep the
    // email action visually primary and let the customer choose it explicitly.
    return false;
  }

  function owningAccount(node) {
    var current = node && node.host ? node.host : node;
    var guard = 0;
    while (current && guard < 12) {
      if (current.matches && current.matches(ACCOUNT_SELECTOR)) return current;
      var tree = current.getRootNode ? current.getRootNode() : null;
      if (tree && tree.host) current = tree.host;
      else current = current.parentElement;
      guard += 1;
    }
    return null;
  }

  function accountEmailInput(account) {
    if (!account || !account.shadowRoot) return null;
    var loginForm = account.shadowRoot.querySelector('shopify-login-form');
    if (!loginForm || !loginForm.shadowRoot) return null;
    var emailInput = loginForm.shadowRoot.querySelector('input[type="email"], input[autocomplete="email"]');
    return isRendered(emailInput) ? emailInput : null;
  }

  function activeDeepElement() {
    var active = document.activeElement;
    var guard = 0;
    while (active && active.shadowRoot && active.shadowRoot.activeElement && guard < 12) {
      active = active.shadowRoot.activeElement;
      guard += 1;
    }
    return active;
  }

  function isTextEntryActive() {
    var active = activeDeepElement();
    if (!active) return false;
    return active.tagName === 'INPUT' || active.tagName === 'TEXTAREA' || active.isContentEditable;
  }

  function translateEmailSwitch(candidate) {
    if (!candidate || !isItalian()) return;
    candidate.setAttribute('aria-label', 'Usa l\u2019email');
    candidate.setAttribute('data-florame-email-switch', 'primary');
    var translated = false;
    Array.prototype.forEach.call(candidate.childNodes || [], function (node) {
      if (node.nodeType !== 3 || !isEmailSwitchText(String(node.nodeValue || '').replace(/\s+/g, ' ').trim().toLowerCase())) return;
      if (node.nodeValue !== 'Usa l\u2019email') node.nodeValue = 'Usa l\u2019email';
      translated = true;
    });
    Array.prototype.forEach.call(candidate.querySelectorAll('*'), function (element) {
      if (element.children.length > 0 || !isEmailSwitchText(normalizedText(element))) return;
      if (element.textContent !== 'Usa l\u2019email') element.textContent = 'Usa l\u2019email';
      translated = true;
    });
    if (!translated && isEmailSwitchText(normalizedText(candidate))) candidate.textContent = 'Usa l\u2019email';
  }

  function markShopActions(root) {
    if (!root || !root.querySelectorAll) return;
    var controls = root.querySelectorAll('button, a, [role="button"]');
    Array.prototype.forEach.call(controls, function (control) {
      if (isShopActionText(normalizedText(control))) control.setAttribute('data-florame-shop-action', 'secondary');
    });
  }

  function rememberShopAttempt() {
    try { window.sessionStorage.setItem(SHOP_ATTEMPT_KEY, String(Date.now())); } catch (_) {}
  }

  function pendingShopAttemptAt() {
    try { return Number(window.sessionStorage.getItem(SHOP_ATTEMPT_KEY) || 0); } catch (_) { return 0; }
  }

  function clearShopAttempt() {
    try { window.sessionStorage.removeItem(SHOP_ATTEMPT_KEY); } catch (_) {}
  }

  function bindShopAttemptRecovery(root) {
    if (!root || !root.addEventListener) return;
    if (shopAttemptBoundRoots && shopAttemptBoundRoots.has(root)) return;
    if (shopAttemptBoundRoots) shopAttemptBoundRoots.add(root);
    root.addEventListener('click', function (event) {
      var control = event.target && event.target.closest
        ? event.target.closest('[data-testid="login-button"], [data-florame-shop-action="secondary"]')
        : null;
      if (!control || !isShopActionText(normalizedText(control))) return;
      rememberShopAttempt();
    }, true);
  }

  function resetShopVisualState(root) {
    if (!root || !root.querySelectorAll) return;
    Array.prototype.forEach.call(root.querySelectorAll('[data-testid="shop-login-spinner"]'), function (spinner) {
      spinner.setAttribute('data-visible', 'false');
      spinner.setAttribute('aria-hidden', 'true');
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-testid="login-button"]'), function (button) {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    });
  }

  function recoverCancelledShopAttempt() {
    var attemptedAt = pendingShopAttemptAt();
    if (!attemptedAt || Date.now() - attemptedAt < 450 || document.visibilityState === 'hidden') return;
    clearShopAttempt();
    Array.prototype.forEach.call(document.querySelectorAll(ACCOUNT_SELECTOR), function (account) {
      if (!account.shadowRoot) return;
      var root = account.shadowRoot;
      Array.prototype.forEach.call(root.querySelectorAll('shop-login'), function (shopLogin) {
        if (shopLogin.shadowRoot) resetShopVisualState(shopLogin.shadowRoot);
      });
      var dialog = root.querySelector('dialog');
      if (dialog && dialog.open) closeFromSwipe(dialog, root);
    });
  }

  function requestEmailFirst(root) {
    if (!root || !root.querySelectorAll) return;
    var account = owningAccount(root);
    var candidates = root.querySelectorAll('button, a, [role="button"]');
    for (var index = 0; index < candidates.length; index += 1) {
      var candidate = candidates[index];
      var text = normalizedText(candidate);
      if (!isEmailSwitchText(text)) continue;

      translateEmailSwitch(candidate);
      if (!shouldAutoOpenEmail(account, candidate)) break;
      if ((account && accountEmailInput(account)) || isTextEntryActive()) break;
      if (account && emailRequestedAccounts && emailRequestedAccounts.has(account)) break;
      if (!account && emailRequestedRoots && emailRequestedRoots.has(root)) break;
      if (account && emailRequestedAccounts) emailRequestedAccounts.add(account);
      else if (emailRequestedRoots) emailRequestedRoots.add(root);
      try { candidate.click(); } catch (_) {}
      break;
    }
  }

  function styleShopLogin(shopLogin) {
    if (!shopLogin || !shopLogin.shadowRoot) return;
    var root = shopLogin.shadowRoot;
    markShopActions(root);
    bindShopAttemptRecovery(root);
    appendStyle(root, 'shop-secondary', [
      '[data-testid="login-button"], [data-florame-shop-action="secondary"] {',
      '  background: #ffffff !important;',
      '  color: #513a43 !important;',
      '  border: 1px solid rgba(81, 58, 67, .18) !important;',
      '  box-shadow: none !important;',
      '}',
      '[data-testid="login-button"] span, [data-florame-shop-action="secondary"] span { color: #513a43 !important; }',
      '[data-testid="login-button"] svg, [data-florame-shop-action="secondary"] svg { color: #513a43 !important; }',
      '[data-testid="login-button"] svg path, [data-florame-shop-action="secondary"] svg path { fill: #513a43 !important; }',
      '[data-testid="login-button"]:hover, [data-florame-shop-action="secondary"]:hover { background: #fff6f9 !important; }',
      '[data-florame-email-switch="primary"] {',
      '  min-height: 54px !important;',
      '  background: #ff4d75 !important;',
      '  color: #ffffff !important;',
      '  border: 1px solid #ff4d75 !important;',
      '  border-radius: 999px !important;',
      '  font-weight: 750 !important;',
      '  box-shadow: 0 10px 24px rgba(255, 77, 117, .22) !important;',
      '  order: -1 !important;',
      '}',
      '[data-florame-email-switch="primary"] span { color: #ffffff !important; }',
      '[data-florame-email-switch="primary"]:hover { background: #e62f61 !important; }'
    ].join('\n'));
    requestEmailFirst(root);
    observeRoot(root);
  }

  function styleLoginForm(loginForm) {
    if (!loginForm || !loginForm.shadowRoot) return;
    var root = loginForm.shadowRoot;
    var divider = root.querySelector('.login-form__divider');
    var google = root.querySelector('[data-provider="google"]');

    if (!marketingConsentReviewedRoots || !marketingConsentReviewedRoots.has(root)) {
      var marketingConsent = root.querySelector(
        '.login-form__marketing-consent-checkbox, .login-form__marketing-consent input[type="checkbox"], input[name*="marketing"], input[name*="accepts_marketing"]'
      );
      if (marketingConsent) {
        if (marketingConsentReviewedRoots) marketingConsentReviewedRoots.add(root);
        var marketingWasChecked = !!(marketingConsent.checked || marketingConsent.defaultChecked || marketingConsent.hasAttribute('checked'));
        marketingConsent.defaultChecked = false;
        marketingConsent.removeAttribute('checked');
        if (marketingConsent.checked) {
          try { marketingConsent.click(); }
          catch (_) {
            marketingConsent.checked = false;
            try { marketingConsent.dispatchEvent(new Event('change', { bubbles: true, composed: true })); } catch (_) {}
          }
        }
        if (marketingWasChecked && !marketingConsent.checked) {
          try { marketingConsent.dispatchEvent(new Event('input', { bubbles: true, composed: true })); } catch (_) {}
          try { marketingConsent.dispatchEvent(new Event('change', { bubbles: true, composed: true })); } catch (_) {}
        }
        marketingConsent.setAttribute('data-florame-opt-in-default', 'off');
      }
    }

    if (divider) {
      divider.setAttribute('aria-label', isItalian() ? 'oppure' : 'or');
      var dividerText = divider.querySelector('.login-form__divider-text');
      var expectedDividerText = isItalian() ? 'oppure' : 'or';
      if (dividerText && dividerText.textContent !== expectedDividerText) dividerText.textContent = expectedDividerText;
    }
    if (google) google.hidden = isWebView();

    appendStyle(root, 'email-first', [
      '.login-form__root { display: flex !important; flex-direction: column !important; gap: 12px !important; }',
      '.login-form__email-form { order: -4; margin: 0 !important; }',
      '.login-form__email-input-wrapper {',
      '  min-height: 56px !important;',
      '  border: 2px solid #ff4d75 !important;',
      '  border-radius: 15px !important;',
      '  box-shadow: 0 8px 24px rgba(255, 77, 117, .12) !important;',
      '}',
      '.login-form__email-input { font-size: 16px !important; }',
      '.login-form__email-submit { background: #ff4d75 !important; color: #ffffff !important; }',
      '.login-form__marketing-consent { order: -3; }',
      '.login-form__divider { order: -2; margin: 2px 0 !important; }',
      '.login-form__divider-text { color: #7a6870 !important; font-size: 12px !important; text-transform: lowercase !important; }',
      '.login-form__social-login-button[data-provider="google"] { background: #ffffff !important; color: #513a43 !important; border: 1px solid rgba(81, 58, 67, .16) !important; box-shadow: none !important; }',
      isWebView() ? '.login-form__social-login-button[data-provider="google"] { display: none !important; }' : ''
    ].join('\n'));

    var shopLogin = root.querySelector('shop-login');
    if (shopLogin) styleShopLogin(shopLogin);
    requestEmailFirst(root);
    observeRoot(root);
  }

  function updateViewportMetrics() {
    viewportScheduled = false;
    var visual = window.visualViewport;
    var viewportHeight = visual && visual.height ? visual.height : window.innerHeight;
    var viewportTop = visual && typeof visual.offsetTop === 'number' ? visual.offsetTop : 0;
    var layoutHeight = Math.max(window.innerHeight || 0, document.documentElement.clientHeight || 0);
    var viewportBottom = Math.max(0, layoutHeight - viewportHeight - viewportTop);

    Array.prototype.forEach.call(document.querySelectorAll(ACCOUNT_SELECTOR), function (account) {
      account.style.setProperty('--florame-account-viewport-height', Math.round(viewportHeight) + 'px');
      account.style.setProperty('--florame-account-viewport-top', Math.round(viewportTop) + 'px');
      account.style.setProperty('--florame-account-viewport-bottom', Math.round(viewportBottom) + 'px');
      account.style.setProperty('--florame-account-keyboard-inset', Math.round(viewportBottom) + 'px');
      keepFocusedFieldVisible(account);
    });
  }

  function scheduleViewportMetrics() {
    if (viewportScheduled) return;
    viewportScheduled = true;
    window.requestAnimationFrame(updateViewportMetrics);
  }

  function keepFocusedFieldVisible(account) {
    var input = accountEmailInput(account);
    if (!input || activeDeepElement() !== input || !account.shadowRoot) return;
    var content = account.shadowRoot.querySelector('.account__content');
    if (!content || !content.getBoundingClientRect) return;
    var inputRect = input.getBoundingClientRect();
    var contentRect = content.getBoundingClientRect();
    var topLimit = contentRect.top + 12;
    var bottomLimit = contentRect.bottom - 14;
    var delta = 0;
    if (inputRect.top < topLimit) delta = inputRect.top - topLimit;
    else if (inputRect.bottom > bottomLimit) delta = inputRect.bottom - bottomLimit;
    if (Math.abs(delta) < 2) return;
    try { content.scrollBy({ top: delta, behavior: 'smooth' }); }
    catch (_) { content.scrollTop += delta; }
  }

  function closeFromSwipe(dialog, root) {
    var closeButton = root.querySelector('.account__close, #close-button, button[aria-label*="Chiudi"], button[aria-label*="Close"]');
    dialog.classList.remove('is-florame-dragging', 'is-florame-snap-back');
    dialog.style.removeProperty('--florame-account-drag-y');
    if (closeButton) closeButton.click();
    else if (typeof dialog.close === 'function') dialog.close();
  }

  function guestCopy() {
    if (isItalian()) {
      return {
        benefit: 'Accedi per seguire gli ordini, salvare gli indirizzi e ricevere assistenza più velocemente.',
        assistant: 'Chiedi a Florame',
        assistantSub: 'AI per scegliere, persone per aiutarti',
        language: 'Lingua',
        install: 'Installa Florame',
        help: 'Aiuto e supporto',
        label: 'Strumenti Florame disponibili senza accesso'
      };
    }
    return {
      benefit: 'Sign in to track orders, save addresses and get help faster.',
      assistant: 'Ask Florame',
      assistantSub: 'AI to choose, people to help',
      language: 'Language',
      install: 'Install Florame',
      help: 'Help and support',
      label: 'Florame tools available without signing in'
    };
  }

  function dispatchGuestUtility(utility) {
    try {
      window.dispatchEvent(new CustomEvent('florame:account-utility', {
        detail: { utility: utility, source: 'shopify-login' }
      }));
    } catch (_) {}
  }

  function ensureGuestTools(root, dialog) {
    if (!root || !dialog) return;
    var content = root.querySelector('.account__content');
    if (!content) return;
    var copy = guestCopy();
    var tools = content.querySelector('[data-florame-guest-tools]');

    if (!tools) {
      tools = document.createElement('section');
      tools.className = 'florame-account-guest-tools';
      tools.setAttribute('data-florame-guest-tools', '1');
      tools.setAttribute('aria-label', copy.label);

      var assistant = document.createElement('button');
      assistant.type = 'button';
      assistant.className = 'florame-account-guest-assistant';
      assistant.setAttribute('data-florame-guest-utility', 'assistant');
      assistant.setAttribute('aria-label', copy.assistant + '. ' + copy.assistantSub);

      var assistantIcon = document.createElement('span');
      assistantIcon.className = 'florame-account-guest-assistant__icon';
      assistantIcon.setAttribute('aria-hidden', 'true');
      assistantIcon.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m4 20 9.8-9.8"/><path d="M12.5 4.5l.7-2 .7 2 2 .7-2 .7-.7 2-.7-2-2-.7 2-.7Z"/><path d="M18.2 12.8l.6-1.7.6 1.7 1.7.6-1.7.6-.6 1.7-.6-1.7-1.7-.6 1.7-.6Z"/></svg>';

      var assistantCopy = document.createElement('span');
      assistantCopy.className = 'florame-account-guest-assistant__copy';
      var assistantTitle = document.createElement('strong');
      var assistantLabel = document.createElement('span');
      assistantLabel.className = 'florame-account-guest-assistant__label';
      assistantLabel.textContent = copy.assistant;
      assistantTitle.appendChild(assistantLabel);
      var assistantBadge = document.createElement('span');
      assistantBadge.className = 'florame-account-guest-assistant__badge';
      assistantBadge.textContent = 'AI';
      assistantTitle.appendChild(assistantBadge);
      var assistantSub = document.createElement('em');
      assistantSub.textContent = copy.assistantSub;
      assistantCopy.appendChild(assistantTitle);
      assistantCopy.appendChild(assistantSub);

      var assistantChevron = document.createElement('span');
      assistantChevron.className = 'florame-account-guest-assistant__chevron';
      assistantChevron.setAttribute('aria-hidden', 'true');
      assistantChevron.textContent = '›';

      assistant.appendChild(assistantIcon);
      assistant.appendChild(assistantCopy);
      assistant.appendChild(assistantChevron);
      assistant.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        assistant.setAttribute('aria-busy', 'true');
        closeFromSwipe(dialog, root);
        window.setTimeout(function () {
          var inbox = window.FlorameShopifyInbox;
          var opener = inbox && typeof inbox.open === 'function' ? inbox.open : window.openShopifyInboxFromMenu;
          var result = typeof opener === 'function' ? opener() : false;
          Promise.resolve(result).finally(function () { assistant.removeAttribute('aria-busy'); });
        }, 260);
      });
      tools.appendChild(assistant);

      var benefit = document.createElement('p');
      benefit.className = 'florame-account-guest-benefit';
      benefit.textContent = copy.benefit;
      tools.appendChild(benefit);

      var actions = document.createElement('div');
      actions.className = 'florame-account-guest-actions';
      ['language', 'install', 'help'].forEach(function (utility) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'florame-account-guest-action';
        button.setAttribute('data-florame-guest-utility', utility);
        button.textContent = copy[utility];
        button.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          if (utility === 'install') {
            var api = window.FlorameAccountCenter;
            if (api && typeof api.install === 'function') api.install();
            else dispatchGuestUtility(utility);
            closeFromSwipe(dialog, root);
            return;
          }
          closeFromSwipe(dialog, root);
          window.setTimeout(function () { dispatchGuestUtility(utility); }, 260);
        });
        actions.appendChild(button);
      });
      tools.appendChild(actions);
      content.appendChild(tools);
    }

    tools.setAttribute('aria-label', copy.label);
    var benefitCopy = tools.querySelector('.florame-account-guest-benefit');
    if (benefitCopy) benefitCopy.textContent = copy.benefit;
    var assistantButton = tools.querySelector('.florame-account-guest-assistant');
    if (assistantButton) {
      assistantButton.setAttribute('aria-label', copy.assistant + '. ' + copy.assistantSub);
      var assistantTitleCopy = assistantButton.querySelector('.florame-account-guest-assistant__label');
      var assistantSubCopy = assistantButton.querySelector('.florame-account-guest-assistant__copy em');
      if (assistantTitleCopy) assistantTitleCopy.textContent = copy.assistant;
      if (assistantSubCopy) assistantSubCopy.textContent = copy.assistantSub;
    }
    Array.prototype.forEach.call(tools.querySelectorAll('[data-florame-guest-utility]'), function (button) {
      var utility = button.getAttribute('data-florame-guest-utility');
      if (utility !== 'assistant') button.textContent = copy[utility] || utility;
      if (utility !== 'install') return;
      var api = window.FlorameAccountCenter;
      button.hidden = !!(api && typeof api.canInstall === 'function' && !api.canInstall());
    });
  }

  function bindSwipeToClose(account, root, dialog) {
    if (!dialog || !root) return;
    if (swipeBoundDialogs && swipeBoundDialogs.has(dialog)) return;
    if (swipeBoundDialogs) swipeBoundDialogs.add(dialog);

    var surface = root.querySelector('.account__header') || dialog;
    var tracking = false;
    var startY = 0;
    var currentY = 0;
    var startTime = 0;

    function shouldIgnore(target) {
      return !!(target && target.closest && target.closest('button, a, input, textarea, select, [contenteditable="true"]'));
    }

    function start(y, target) {
      if (!dialog.open || !isMobileViewport() || shouldIgnore(target)) return false;
      tracking = true;
      startY = y;
      currentY = y;
      startTime = Date.now();
      dialog.classList.remove('is-florame-snap-back');
      dialog.classList.add('is-florame-dragging');
      return true;
    }

    function move(y, event) {
      if (!tracking) return;
      currentY = y;
      var distance = Math.max(0, currentY - startY);
      dialog.style.setProperty('--florame-account-drag-y', Math.round(distance) + 'px');
      if (distance > 0 && event && event.cancelable) event.preventDefault();
    }

    function finish() {
      if (!tracking) return;
      tracking = false;
      var distance = Math.max(0, currentY - startY);
      var elapsed = Math.max(1, Date.now() - startTime);
      var velocity = distance / elapsed;
      var threshold = Math.min(112, Math.max(72, window.innerHeight * 0.12));

      if (distance >= threshold || (distance >= 36 && velocity >= 0.48)) {
        closeFromSwipe(dialog, root);
        return;
      }

      dialog.classList.remove('is-florame-dragging');
      dialog.classList.add('is-florame-snap-back');
      dialog.style.removeProperty('--florame-account-drag-y');
      window.setTimeout(function () { dialog.classList.remove('is-florame-snap-back'); }, 220);
    }

    if (window.PointerEvent) {
      surface.addEventListener('pointerdown', function (event) {
        if (!event.isPrimary || !start(event.clientY, event.target)) return;
        if (surface.setPointerCapture) {
          try { surface.setPointerCapture(event.pointerId); } catch (_) {}
        }
      });
      surface.addEventListener('pointermove', function (event) { move(event.clientY, event); }, { passive: false });
      surface.addEventListener('pointerup', finish);
      surface.addEventListener('pointercancel', finish);
    } else {
      surface.addEventListener('touchstart', function (event) {
        if (event.touches && event.touches[0]) start(event.touches[0].clientY, event.target);
      }, { passive: true });
      surface.addEventListener('touchmove', function (event) {
        if (event.touches && event.touches[0]) move(event.touches[0].clientY, event);
      }, { passive: false });
      surface.addEventListener('touchend', finish);
      surface.addEventListener('touchcancel', finish);
    }

    account.setAttribute('data-florame-swipe-ready', '1');
  }

  function personalizeAccount(account) {
    if (!account) return;
    if (account.getAttribute('data-florame-account-bound') !== '1') {
      account.setAttribute('data-florame-account-bound', '1');
      account.addEventListener('open', function () {
        if (emailRequestedAccounts) emailRequestedAccounts.delete(account);
        scheduleViewportMetrics();
        schedule();
      });
    }
    if (!account.shadowRoot) return;
    var root = account.shadowRoot;
    var dialog = root.querySelector('dialog');
    var loginLoader = root.querySelector('shopify-login-form-loader');
    var loginForm = root.querySelector('shopify-login-form');
    var shopLogin = root.querySelector('shop-login');
    var menuRegion = root.querySelector('.account__menu-region');
    var hasLogin = !!(loginLoader || loginForm || shopLogin);

    if (dialog && !dialog.open && emailRequestedAccounts) emailRequestedAccounts.delete(account);
    if (menuRegion) menuRegion.hidden = hasLogin;
    appendStyle(root, 'single-surface', [
      '.account__content { padding-bottom: max(20px, env(safe-area-inset-bottom)) !important; }',
      '.account__login-slot { margin-bottom: 0 !important; }',
      '.account__menu-region[hidden] { display: none !important; }',
      '.florame-account-guest-tools { margin: 14px 2px 0; padding-top: 12px; border-top: 1px solid #f2ecea; }',
      '.florame-account-guest-assistant { display: grid; grid-template-columns: 34px minmax(0, 1fr) 20px; align-items: center; gap: 11px; width: 100%; min-height: 58px; padding: 9px 10px; border: 0; border-radius: 11px; background: linear-gradient(90deg, #fff0f4, rgba(255,255,255,0) 82%); box-shadow: none; color: #2b2226; text-align: left; cursor: pointer; touch-action: manipulation; transition: background-color .16s ease, transform .16s ease; }',
      '.florame-account-guest-assistant__icon { display: grid; place-items: center; width: 34px; height: 34px; border: 0; border-radius: 11px; background: linear-gradient(135deg, #ed356a, #ff7067); box-shadow: none; color: #fff; }',
      '.florame-account-guest-assistant__icon svg { width: 18px; height: 18px; fill: none; stroke: currentColor; stroke-width: 1.8; stroke-linecap: round; stroke-linejoin: round; }',
      '.florame-account-guest-assistant__copy { display: grid; min-width: 0; gap: 2px; }',
      '.florame-account-guest-assistant__copy strong { display: flex; align-items: center; gap: 7px; color: #2f2026; font-size: 14px; font-weight: 820; line-height: 1.2; }',
      '.florame-account-guest-assistant__badge { display: inline-flex; align-items: center; min-height: 18px; padding: 2px 6px; border: 1px solid rgba(237,53,106,.2); border-radius: 999px; background: #fff; color: #b92755; font-size: 9px; font-weight: 900; letter-spacing: .06em; line-height: 1; }',
      '.florame-account-guest-assistant__copy em { overflow: hidden; color: #705e65; font-size: 12px; font-style: normal; font-weight: 580; line-height: 1.35; text-overflow: ellipsis; white-space: nowrap; }',
      '.florame-account-guest-assistant__chevron { display: grid; place-items: center; width: 20px; height: 30px; background: transparent; color: #9d9298; font-size: 22px; font-weight: 500; line-height: 1; }',
      '.florame-account-guest-assistant:hover { background: linear-gradient(90deg, #ffe8ef, #fff 82%); transform: translateY(-1px); }',
      '.florame-account-guest-assistant:focus-visible { outline: 3px solid rgba(255, 77, 117, .34); outline-offset: 3px; }',
      '.florame-account-guest-assistant[aria-busy="true"] { opacity: .72; pointer-events: none; }',
      '.florame-account-guest-benefit { margin: 0; padding: 5px 12px 9px 56px; border-radius: 0; background: transparent; color: #786a70; font-size: 11.5px; font-weight: 560; line-height: 1.4; text-align: left; }',
      '.florame-account-guest-actions { display: grid; grid-template-columns: repeat(auto-fit, minmax(92px, 1fr)); gap: 1px; margin-top: 7px; overflow: hidden; border: 1px solid rgba(81, 58, 67, .12); border-radius: 13px; background: rgba(81, 58, 67, .12); }',
      '.florame-account-guest-action { min-width: 0; min-height: 44px; padding: 8px 7px; border: 0; border-radius: 0; background: #ffffff; color: #513a43; font: inherit; font-size: 13px; font-weight: 720; line-height: 1.2; cursor: pointer; touch-action: manipulation; }',
      '.florame-account-guest-action:hover { background: #fff7f9; }',
      '.florame-account-guest-action:focus-visible { position: relative; z-index: 1; outline: 2px solid #ff4d75; outline-offset: -2px; }',
      '.florame-account-guest-action[hidden] { display: none !important; }',
      '@media (max-width: 989px) {',
      '  dialog.dialog {',
      '    inset-block-start: auto !important;',
      '    inset-block-end: var(--florame-account-viewport-bottom, 0px) !important;',
      '    top: auto !important;',
      '    bottom: var(--florame-account-viewport-bottom, 0px) !important;',
      '    height: min(480px, calc(var(--florame-account-viewport-height, 100dvh) - 12px)) !important;',
      '    min-height: 0 !important;',
      '    max-height: calc(var(--florame-account-viewport-height, 100dvh) - 12px) !important;',
      '    margin-block: 0 !important;',
      '    border-radius: 24px 24px 0 0 !important;',
      '  }',
      '  .account { display: flex !important; flex-direction: column !important; height: 100% !important; min-height: 0 !important; max-height: 100% !important; }',
      '  .account__header-region { flex: 0 0 auto; }',
      '  .account__header { position: relative !important; min-height: 70px !important; padding-top: 18px !important; touch-action: none; }',
      '  .account__close { width: 44px !important; min-width: 44px !important; height: 44px !important; min-height: 44px !important; }',
      '  .account__header::before {',
      '    content: "";',
      '    position: absolute;',
      '    top: 7px;',
      '    left: 50%;',
      '    width: 42px;',
      '    height: 5px;',
      '    border-radius: 999px;',
      '    background: rgba(21, 32, 25, .24);',
      '    transform: translateX(-50%);',
      '  }',
      '  .account__content { flex: 1 1 auto !important; min-height: 0 !important; overflow: hidden auto !important; overscroll-behavior: contain; scroll-padding: 12px 0 16px; -webkit-overflow-scrolling: touch; }',
      '  dialog.dialog.is-florame-dragging { transition: none !important; transform: translate3d(0, var(--florame-account-drag-y, 0px), 0) !important; }',
      '  dialog.dialog.is-florame-snap-back { transition: transform 180ms ease-out !important; transform: translate3d(0, 0, 0) !important; }',
      '}',
      '@media (prefers-reduced-motion: reduce) { dialog.dialog.is-florame-snap-back { transition: none !important; } }'
    ].join('\n'));

    if (dialog) bindSwipeToClose(account, root, dialog);
    if (loginForm) styleLoginForm(loginForm);
    if (hasLogin && dialog) ensureGuestTools(root, dialog);
    if (!hasLogin) {
      var guestTools = root.querySelector('[data-florame-guest-tools]');
      if (guestTools) guestTools.remove();
    }
    requestEmailFirst(root);
    observeRoot(root);
  }

  function inspectTree(root) {
    if (!root || !root.querySelectorAll) return;
    Array.prototype.forEach.call(root.querySelectorAll(ACCOUNT_SELECTOR), personalizeAccount);
    if (root.host && root.host.matches && root.host.matches(ACCOUNT_SELECTOR)) personalizeAccount(root.host);

    Array.prototype.forEach.call(root.querySelectorAll('*'), function (element) {
      if (element.shadowRoot) {
        if (element.tagName === 'SHOPIFY-LOGIN-FORM') styleLoginForm(element);
        else if (element.tagName === 'SHOP-LOGIN') styleShopLogin(element);
        requestEmailFirst(element.shadowRoot);
        observeRoot(element.shadowRoot);
        inspectTree(element.shadowRoot);
      }
    });
  }

  function run() {
    scheduled = false;
    inspectTree(document);
    scheduleViewportMetrics();
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(run);
  }

  function observeRoot(root) {
    if (!root || !window.MutationObserver) return;
    if (observedRoots && observedRoots.has(root)) return;
    if (observedRoots) observedRoots.add(root);
    var observer = new MutationObserver(schedule);
    observer.observe(root, { childList: true, subtree: true });
  }

  document.addEventListener('open', function (event) {
    var account = event.target && event.target.closest ? event.target.closest(ACCOUNT_SELECTOR) : null;
    if (account && emailRequestedAccounts) emailRequestedAccounts.delete(account);
    if (account) personalizeAccount(account);
    schedule();
  }, true);
  document.addEventListener('focusin', function (event) {
    var path = event.composedPath ? event.composedPath() : [];
    var insideAccount = path.some ? path.some(function (node) {
      return node && node.matches && node.matches(ACCOUNT_SELECTOR);
    }) : false;
    if (!insideAccount) return;
    scheduleViewportMetrics();
    window.setTimeout(scheduleViewportMetrics, 80);
    window.setTimeout(scheduleViewportMetrics, 280);
    window.setTimeout(function () {
      Array.prototype.forEach.call(document.querySelectorAll(ACCOUNT_SELECTOR), keepFocusedFieldVisible);
    }, 360);
  }, true);
  window.addEventListener('resize', scheduleViewportMetrics, { passive: true });
  window.addEventListener('orientationchange', scheduleViewportMetrics, { passive: true });
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', scheduleViewportMetrics, { passive: true });
    window.visualViewport.addEventListener('scroll', scheduleViewportMetrics, { passive: true });
  }
  window.addEventListener('florame:native-ready', schedule);
  window.addEventListener('florame:pwa-install-state', schedule);
  window.addEventListener('pageshow', function () { window.setTimeout(recoverCancelledShopAttempt, 120); });
  window.addEventListener('focus', function () { window.setTimeout(recoverCancelledShopAttempt, 120); });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') window.setTimeout(recoverCancelledShopAttempt, 120);
  });
  observeRoot(document.documentElement);
  if (window.customElements && typeof window.customElements.whenDefined === 'function') {
    window.customElements.whenDefined('shopify-account').then(run).catch(function () {});
  }

  window.FlorameShopifyAccountUi = {
    loaded: true,
    version: '1.5.1',
    refresh: run,
    isWebView: isWebView
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  else run();
  window.setTimeout(run, 300);
})();
